import { AlertCircle } from "lucide-react";
import { Link } from "@tanstack/react-router";

import {
	Alert,
	AlertDescription,
	AlertTitle,
} from "@workspace/ui/components/alert";

import { EposSystem } from "./components/epos-system";
import { useEposContext } from "./epos-context/context";
import { EposContextProvider } from "./epos-context/context-provider";

interface EposDisplayProps {
	active: boolean;
}

export function EposDisplay(props: EposDisplayProps) {
	const { active } = props;

	return (
		active && (
			<EposContextProvider>
				<EposDisplayTab />
			</EposContextProvider>
		)
	);
}

function EposDisplayTab() {
	const { venueId, currentMenu, tenant } = useEposContext();

	if (!currentMenu) {
		return (
			<div
				className="flex h-[var(--kiosk-vh,100vh)] items-center justify-center p-4"
				role="region"
				aria-labelledby="no-menu-title"
				aria-describedby="no-menu-desc"
			>
				<Alert
					className="w-full max-w-xl"
					variant="destructive"
					role="alert"
					aria-live="assertive"
					aria-labelledby="no-menu-title"
					aria-describedby="no-menu-desc"
				>
					<AlertCircle />

					<AlertTitle
						id="no-menu-title"
						className="scroll-m-20 text-2xl font-semibold tracking-tight"
					>
						No menu selected for this terminal
					</AlertTitle>

					<AlertDescription id="no-menu-desc">
						Please contact a manager to assign a menu to this terminal.
					</AlertDescription>

					<div className="mt-4 flex justify-end col-span-2">
						<Link
							to="/$tenant/venues/$venueId"
							params={{ tenant, venueId }}
							aria-label={`Back to venue ${venueId}`}
						>
							Back
						</Link>
					</div>
				</Alert>
			</div>
		);
	}

	return (
		<>
			<div className="flex h-[var(--kiosk-vh,100vh)] flex-col overflow-auto p-2 items-center w-full">
				<EposSystem />
			</div>
		</>
	);
}
